import { motion } from "framer-motion";
import { RadioTower, SwitchCamera, UserPlus, Flame, Sparkles } from "lucide-react";

const CARDS = [
  {
    title: "Go live in seconds",
    description: "Start an IN and broadcast your moment the second it happens — concerts, dinners, street sessions, 2 AM kitchens.",
    badge: "LIVE",
    icon: RadioTower,
    span: "md:col-span-8 md:row-span-2",
    image: "/assets/app-2.webp",
  },
  {
    title: "Jump between lives",
    description: "People at the same place show up as green dots in the live. Tap one and you're suddenly watching the same moment — from their angle.",
    badge: "EVERY ANGLE",
    icon: SwitchCamera,
    span: "md:col-span-4",
  },
  {
    title: "Bring people IN",
    description: "Invite the ones you want beside you, wherever they are in the world.",
    badge: "INVITE",
    icon: UserPlus,
    span: "md:col-span-4",
  },
  {
    title: "Reactions that move the room",
    description: "Fire, hearts and hype land live on the host's screen while the moment is still happening.",
    badge: "REAL-TIME",
    icon: Flame,
    span: "md:col-span-6",
  },
  {
    title: "Catch up on Highlights",
    description: "Missed the moment? Catch the highlight before it fades — every IN is temporary.",
    badge: "HIGHLIGHTS",
    icon: Sparkles,
    span: "md:col-span-6",
  },
];

export const FeaturesBento = () => {
  return (
    <section id="features" className="relative py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-coral mb-4">WHAT YOU CAN DO</p>
          <h2 className="font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
            One tap and you're <span className="text-brand-gradient">IN.</span>
          </h2>
        </motion.div>

        <div data-testid="features-bento-grid" className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {CARDS.map((card, i) => (
            <motion.div
              key={card.title}
              data-testid={`feature-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              whileHover={{ y: -6 }}
              className={`group relative overflow-hidden rounded-3xl border border-white/10 bg-ink-card/60 min-h-[220px] p-7 flex flex-col justify-end transition-colors duration-300 hover:border-ink-pink/30 ${card.span}`}
            >
              {card.image && (
                <>
                  <img src={card.image} alt="" className="absolute inset-0 w-full h-full object-cover object-[center_15%] opacity-40 group-hover:opacity-55 transition-opacity duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050508] via-[#050508]/70 to-transparent" />
                </>
              )}
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <span className="rounded-full border border-ink-coral/40 bg-ink-coral/10 px-3 py-1 font-mono text-[10px] tracking-[0.25em] text-ink-coral">
                    {card.badge}
                  </span>
                  <card.icon className="w-4 h-4 text-zinc-500 group-hover:text-ink-coral transition-colors duration-300" />
                </div>
                <h3 className="font-display font-bold text-white text-xl sm:text-2xl tracking-tight mb-2">{card.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed max-w-md">{card.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
